import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "grid grid-cols-2 w-18/20" }
const _hoisted_2 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_3 = { class: "grid grid-cols-2 w-18/20" }
const _hoisted_4 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_5 = { class: "w-15/20" }
const _hoisted_6 = /*#__PURE__*/_createVNode("hr", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Title = _resolveComponent("Title")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_TableV2 = _resolveComponent("TableV2")!
  const _component_ChipsV2 = _resolveComponent("ChipsV2")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_DetailLayout = _resolveComponent("DetailLayout")!

  return (_openBlock(), _createBlock(_component_DetailLayout, {
    scrollSidebar: "",
    customClass: "px-0",
    onBack: _ctx.goBack,
    title: "Detail Cashback",
    loading: _ctx.apiDetailData.loading,
    error: !!_ctx.apiDetailData.errorType,
    errorType: _ctx.apiDetailData.errorType,
    onTryAgain: _ctx.fetchDetail
  }, {
    data: _withCtx(() => [
      _createVNode(_component_Title, {
        label: "Kriteria Partner",
        class: "text-20px"
      }),
      _createVNode("div", _hoisted_1, [
        _createVNode(_component_DataWrapper, {
          class: "capitalize",
          label: "Tipe Akun",
          value: _ctx.detailData.data.ccbAccountType
        }, null, 8, ["value"]),
        _createVNode(_component_DataWrapper, {
          label: "Nama POS",
          value: _ctx.posName
        }, null, 8, ["value"])
      ]),
      _hoisted_2,
      _createVNode(_component_Title, {
        label: "Aturan Cashback",
        class: "text-20px"
      }),
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_DataWrapper, {
          label: "Tanggal Mulai",
          value: _ctx.detailData.data.formatStartDate
        }, null, 8, ["value"]),
        _createVNode(_component_DataWrapper, {
          label: "Tanggal Berakhir",
          value: _ctx.detailData.data.formatEndDate
        }, null, 8, ["value"]),
        _createVNode(_component_DataWrapper, {
          label: "Tipe Cashback",
          class: "mt-8 capitalize",
          value: _ctx.ccbTypeValue
        }, null, 8, ["value"])
      ]),
      _hoisted_4,
      _createVNode(_component_Title, {
        label: "Perhitungan Tier",
        class: "text-20px"
      }),
      _createVNode("div", _hoisted_5, [
        _createVNode(_component_TableV2, {
          data: _ctx.detailData.data.ccbTiers,
          columns: _ctx.columns,
          hidePagination: "",
          borderTop: false,
          borderBottom: false
        }, null, 8, ["data", "columns"])
      ]),
      _hoisted_6
    ]),
    "sub-data": _withCtx(() => [
      _createVNode(_component_DataWrapper, { label: "Status" }, {
        default: _withCtx(() => [
          _createVNode(_component_ChipsV2, {
            class: "pt-2",
            label: _ctx.detailData.data.ccbStatus
          }, null, 8, ["label"])
        ]),
        _: 1
      }),
      _createVNode(_component_DataWrapper, {
        label: "Terakhir Diubah",
        value: _ctx.detailData.data.formatCreatedAt,
        caption: _ctx.detailData.data.ccbCreatedBy
      }, null, 8, ["value", "caption"]),
      _createVNode(_component_DataWrapper, {
        class: "capitalize",
        label: "Tanggal Dibuat",
        value: _ctx.detailData.data.formatUpdatedAt,
        caption: _ctx.detailData.data.ccbUpdatedBy
      }, null, 8, ["value", "caption"]),
      _withDirectives(_createVNode(_component_LpButton, {
        title: "Ubah",
        customClass: "w-1/2",
        onClick: _ctx.goToEdit,
        outline: "",
        textColor: "red-lp-100"
      }, null, 8, ["onClick"]), [
        [_vShow, _ctx.isEditAble]
      ])
    ]),
    _: 1
  }, 8, ["onBack", "loading", "error", "errorType", "onTryAgain"]))
}